import { availabilityReminderSubmitTracking } from '../Produktdetails/ProductGoogleTracking';
import { trackIdLayerReduced } from '../Tracking/GoogleTracking';
import { checkForCloudflare, cloudflareId } from './userCentrics';

declare var __ucCmp: any;
declare var turnstile: any;
let currentProductId: string;
let currentTrackingEvent: string;
let modalForm: boolean;

$(() => {
    /**
     * Wird getriggert, wenn auf einen Button zum öffnen des Reminder Modals gedrückt wird
     */
    $(document).on('click', '.openSendReminderModal', function() {
        const productId = $(this).data('id');
        const trackingEvent = $(this).data('tracking');

        modalForm = true;
        currentTrackingEvent = trackingEvent;
        currentProductId = productId;
        const modal = $('#modalSendReminder');
        if (window['turnstile'] == undefined) {

            loadCloudflare();
        } else {
            intiCloudflare();
        }
        if (productId) {
            $(modal).modal();
        }
    });
});

/**
 * Triggers form submit for availabity reminder
 */
$('.submitAvailabilityReminder').click(function() {
    let validations = {
        email: [/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/],
    };

    $('#Reminder_Email_Validation').addClass('hide');
    $('#Reminder_Email_Success').addClass('hide');
    $('#Reminder_Email_Server_Error').addClass('hide');
    $('#Reminder_Email_Validation_Modal').addClass('hide');
    $('#Reminder_Email_Success_Modal').addClass('hide');
    $('#Reminder_Email_Server_Error_Modal').addClass('hide');

    let cloudflareResponse;
    if (turnstile == undefined) {
        $(modalForm ? '#Reminder_Cloudflare_Validation_Modal' : '#Reminder_Cloudflare_Validation').removeClass('hide');
        return false;
    }
    try {
        let widgetId = $(modalForm ? '#reminder-cloudlfare-modal' : '#reminder-cloudlfare').data('widget');
        cloudflareResponse = turnstile.getResponse(widgetId);
    } catch {
        $(modalForm ? '#Reminder_Cloudflare_Validation_Modal' : '#Reminder_Cloudflare_Validation').removeClass('hide');
        return false;
    }
    if (cloudflareResponse.length == 0) {
        $(modalForm ? '#Reminder_Cloudflare_Validation_Modal' : '#Reminder_Cloudflare_Validation').removeClass('hide');
        return false;
    }

    let validation = new RegExp(validations['email'][0]);
    let email = modalForm ? <HTMLInputElement>$('#EmailReminderModal')[0] : <HTMLInputElement>$('#EmailReminder')[0];
    if (!validation.test(email.value)) {
        $('#Reminder_Email_Validation').removeClass('hide');
        return false;
    }

    const productId = $(this).data('id');
    let reminderEntry = {};
    reminderEntry['Email'] = email.value;
    reminderEntry['CloudflareResponse'] = cloudflareResponse;
    reminderEntry['ProductId'] = productId || currentProductId;

    $.post('/Umbraco/Api/AvailiablitySubscription/Subscribe', reminderEntry, async function(data, status) {
        $(modalForm ? '#Reminder_Email_Success_Modal' : '#Reminder_Email_Success').removeClass('hide');
        availabilityReminderSubmitTracking(
            productId ? productId : currentProductId,
            currentTrackingEvent ? currentTrackingEvent : 'erinnnerungsservice'
        );

        if (data) {
            await trackIdLayerReduced(data, 'idLayer_reduced_reminder-service');
        }

        currentTrackingEvent = null;
        currentProductId = null;
        modalForm = false;
        setTimeout(() => {
            $('#modalSendReminder').modal('hide');
            $('#EmailReminder').val('');
            $('#Reminder_Email_Success').addClass('hide');
            turnstile.reset();
        }, 2000);
    }).fail(function(data) {
        $(modalForm ? '#Reminder_Email_Server_Error_Modal' : '#Reminder_Email_Server_Error').removeClass('hide');
    });
});

function loadCloudflare() {
    var script = document.createElement('script');
    script.onload = async function() {
        if (window['__ucCmp'] !== undefined && (await __ucCmp.isInitialized())) {
            await intiCloudflare();
        }
    };
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

    document.head.appendChild(script);
}

async function intiCloudflare() {
    const details = await __ucCmp.getConsentDetails();
    const cloudflareAllowed = details.services[cloudflareId].consent.given;

    checkForCloudflare(cloudflareAllowed, true);
}
